import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { IconType } from '../icons/index.js';
import { TagType } from './tag.component.js';

export type TagListItem = {
	readonly text: string;
	readonly icon?: IconType;
	readonly tagType?: TagType;
	readonly click?: () => void;
};

export type TagListMode = 'default' | 'stacked';

@Component({
	selector: 'lib-tag-list',
	templateUrl: './tag-list.component.html',
	styleUrl: './tag-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TagListComponent {
	@HostBinding('style') style = 'display: block';

	public readonly tags = input.required<readonly TagListItem[]>();
	public readonly mode = input<TagListMode>('default');

	handleClick(tag: TagListItem): void {
		tag.click?.();
	}
}
